import { useReveal } from '@ccg/core';
import React$1 from 'react';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Icon$1 from '../../basics/Icon/Icon.js';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import RevealBox$1 from '../RevealBox/RevealBox.js';
import SpecialHeadline$1 from '../SpecialHeadline/SpecialHeadline.js';
import StyledJobTeaser from './JobTeaser.style.js';

const JobTeaser = ({
  title,
  locations,
  subline,
  link,
  cta
}) => {
  const [ref, isVisible] = useReveal();
  return /*#__PURE__*/React$1.createElement(StyledJobTeaser, {
    ref: ref
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({}, link, {
    noHover: true,
    className: "jobTeaser__link"
  }), /*#__PURE__*/React$1.createElement(RevealBox$1, {
    isVisible: isVisible
  }, locations && locations.length > 0 && /*#__PURE__*/React$1.createElement(Typography$1, {
    variant: "subline",
    transform: "uppercase",
    className: "jobTeaser__locations"
  }, locations.map((item, i) => i !== 0 ? `, ${item.title}` : item.title)), /*#__PURE__*/React$1.createElement("div", {
    className: "jobTeaser__content"
  }, /*#__PURE__*/React$1.createElement(SpecialHeadline$1, {
    as: "h2",
    variant: "subheadline",
    text: title,
    className: "jobTeaser__headline"
  }), (subline || cta) && /*#__PURE__*/React$1.createElement("div", {
    className: "jobTeaser__description"
  }, subline && /*#__PURE__*/React$1.createElement(SpecialHeadline$1, {
    as: "p",
    variant: "inherit",
    text: subline
  }), cta && /*#__PURE__*/React$1.createElement("span", {
    className: "jobTeaser__link-text"
  }, cta, /*#__PURE__*/React$1.createElement(Icon$1, {
    icon: "rightArrow",
    alignment: "right"
  })))))));
};

JobTeaser.propTypes = {
  title: PropTypes$1.string.isRequired,
  link: PropTypes$1.shape().isRequired,
  locations: PropTypes$1.arrayOf(PropTypes$1.shape()),
  subline: PropTypes$1.string,
  cta: PropTypes$1.string
};
JobTeaser.defaultProps = {
  locations: null,
  subline: null,
  cta: null
};

export default JobTeaser;
